<app-retailer-top-bar [showBackArrow]="true" [previousPage]="'/retailer'"
                      (onBack)="onLeaveUsecase()" (onNewStudio)="onNewStudio()"></app-retailer-top-bar>
<div class="w-full relative">
    <img src="/assets/images/select-vehicle-model-header.png" alt="Select Vehicle Model" class="w-full">
    <h1
            class="text-white font-light text-4xl absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
        Select a car model to discover its available materials.
    </h1>
</div>
<div class="my-5 flex justify-center items-center">
    <div class="flex flex-col gap-10">
        <div class="flex justify-between items-center">
            <div class="input-container">
                <!-- SVG Icon -->
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.941 0C10.4768 0.00137155 9.04073 0.40138 7.78672 1.1571C6.53271 1.91283 5.50814 2.99574 4.82295 4.28964C4.13776 5.58354 3.81782 7.03959 3.89745 8.50154C3.97709 9.9635 4.45329 11.3762 5.27497 12.588L0.143966 17.719C0.0506379 17.8136 -0.0013522 17.9414 -0.000602352 18.0743C0.000147495 18.2072 0.053576 18.3344 0.147966 18.428L1.56997 19.856C1.66797 19.947 1.79597 20.001 1.92897 20.001C2.06197 20.001 2.19097 19.946 2.28597 19.853L2.28297 19.856L7.41197 14.725C8.62335 15.5479 10.036 16.0252 11.4983 16.1056C12.9605 16.1861 14.417 15.8666 15.7114 15.1815C17.0057 14.4965 18.0889 13.4717 18.8447 12.2174C19.6005 10.963 20.0002 9.52644 20.001 8.062C20.0002 5.92433 19.1506 3.87445 17.6391 2.36289C16.1275 0.851332 14.0776 0.00179504 11.94 0.000999928L11.941 0ZM11.941 1.51C15.557 1.511 18.49 4.444 18.49 8.061C18.49 11.678 15.557 14.606 11.94 14.606C8.32297 14.606 5.39397 11.674 5.39397 8.061C5.39582 6.32527 6.08581 4.66108 7.31269 3.43326C8.53958 2.20544 10.2032 1.51418 11.939 1.511"
                          fill="#E8E8E8"/>
                </svg>

                <!-- Input Field -->
                <input type="text" placeholder="Search" (input)="onSearchInputChange()" [(ngModel)]="search"
                       autocomplete="off"/>
            </div>
            <button
                    class="p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200"
                    (click)="lightsOff()"
                    title="Toggle lights off"
                    pTooltip="Toggle lights off"
                    tooltipPosition="right"
                    aria-label="Toggle lights off"
            >
                @if (!turningLightsOff) {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8">
                        <path
                                fill="currentColor"
                                fill-rule="evenodd"
                                d="M10.499 19h3v.5a.502.502 0 0 1-.5.501h-2.001a.503.503 0 0 1-.5-.501V19zm4.937-5.942c-.742.815-1.438 1.577-1.438 2.443v.5H9.999v-.5c0-.866-.695-1.628-1.438-2.443-.994-1.09-2.062-2.261-2.062-4.057 0-3.122 2.53-5 5.499-5s5.499 1.873 5.499 5c0 1.796-1.068 2.967-2.062 4.057zM9.999 9.001h3.999v1h-1.5v5h.546c.183-1.002.898-1.785 1.653-2.615.868-.951 1.801-1.974 1.801-3.385 0-2.573-2.092-3.999-4.5-3.999s-4.5 1.435-4.5 3.999c0 1.411.933 2.434 1.801 3.385.756.83 1.47 1.613 1.654 2.615h.545v-5h-1.5v-1zm3.999 8H9.999v.5c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-.5z"
                        />
                        <line
                                x1="4" y1="4" x2="20" y2="20"
                                stroke="currentColor"
                                stroke-width="1.2"
                                stroke-linecap="round"
                        />
                    </svg>
                } @else {
                    <svg
                            class="h-8 w-8 animate-spin text-gray-800 dark:text-gray-200"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                    >
                        <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="1.2"
                        ></circle>
                        <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                    </svg>
                }

            </button>
        </div>
        <div class="flex justify-center items-center">
            <!-- Model Select Container -->
            <div class="model-select-container">
                <div class="flex items-end">
                    <!-- List of Models -->
                    @for (model of models; track model) {
                        <div
                                (click)="selectModel(model)"
                                [ngClass]="{ 'bg-gray-700 text-white selected-model': selectedModel === model, 'bg-transparent text-gray-800 dark:text-gray-300 unselected-model': selectedModel !== model }"
                                class="flex h-full items-center cursor-pointer px-4 py-2 transition-colors"
                        >
                            <p class="p-1 lg:p-2 text-xs lg:text-sm">{{ model }}</p>
                        </div>
                    }
                </div>
                <p class="my-3 text-light-gray text-sm">{{ vehicle_models.length }} Models</p>
            </div>
        </div>
    </div>

</div>

<div class="grid grid-cols-4 gap-4 px-10 my-10">
    @for (vehicle_model of vehicle_models; track vehicle_model) {
        <div
                (click)="selectVehicleModel(vehicle_model)"
                [ngClass]="{'opacity-40 pointer-events-none': !isAvailable(vehicle_model)}"
                class="vehicle-model-box transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg cursor-pointer">
            <img [src]="vehicle_model.image?.content?.preview?.cloudfrontUrl || 'assets/images/vehicle_fallback.png'"
                 alt="Vehicle Model"
                 class="w-full h-auto">
            <p class="text-center text-lg mt-2 mb-4">{{ vehicle_model.label }}</p>
    </div>
    }
</div>
